import { Component, OnInit, Output } from '@angular/core';
import { Router } from '../../../node_modules/@angular/router';
import { EventEmitter } from '../../../node_modules/protractor';
import { FormGroup, FormBuilder } from '../../../node_modules/@angular/forms';
import { ApiService } from '@app/core';
import { } from '@app/home/home.component';

@Component({
  selector: 'app-bulknotification',
  templateUrl: './bulknotification.component.html',
  styleUrls: ['./bulknotification.component.scss']
})
export class BulknotificationComponent implements OnInit {
  searchForm: FormGroup;
  data: any;
  itemsPerPage: number;
  totalItems: any;
  page: any;
  previousPage: any;
  isSearchOpen: boolean = false;

  subject: string;
  status: string;
  from: string;
  to: string;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService) {
    this.createForm();
  }

  ngOnInit() {
    this.totalItems = 0;
    this.itemsPerPage = 10;
    this.page = 1;
    this.previousPage = this.page;
    this.subject = null;
    this.status = null;
    this.from = null;
    this.to = null;
    this.getNotifications();
  }

  compose() {
    //this.router.navigate(['/identity'], { replaceUrl: true, queryParams: { 'link': 'forgotUsername' } });
    //this.router.navigate(['/home'], { replaceUrl: true, queryParams: { 'tab': 'Notification' } });
    //this.router.navigate(['/home'], { replaceUrl: true, queryParams: { tab: "Notification" } });
    this.router.navigate(['/home'], { queryParams:{ tab: "Notification"} });
    //location.reload();
    setTimeout(() => window.location.reload()); 

  }

  openSearchForm() {
    if (this.isSearchOpen) {
      this.isSearchOpen = false;
    } else {
      this.isSearchOpen = true;
    }
  }

  view(id:number) {
    //alert(id);
    //this.router.navigate(['/home'], { replaceUrl: true, queryParams: { tab: "Notification", id: id, action: "view" } });
    this.router.navigate(['/home'], { queryParams:{ tab: "Notification", id: id, action: "view" } });
        // location.reload();
    setTimeout(() => window.location.reload()); 
   }

  edit(id:number) {
    this.router.navigate(['/home'], { queryParams:{ tab: "Notification", id: id, action: "edit" } });
    //alert(id);
    //this.router.navigate(['/home'], { replaceUrl: true, queryParams: { tab: "Notification", id: "1" } });
    //this.router.navigate(['/home'], { replaceUrl: true, queryParams: { tab: "Notification", id: id,action: "edit" } });
        // location.reload();
    setTimeout(() => window.location.reload());
  }

  search() {
    this.page = 1;
    this.previousPage = this.page;
    this.subject = this.searchForm.value.subject;
    this.status = this.searchForm.value.status;
    this.from = this.getDate(this.searchForm.value.fromDate);
    this.to = this.getDate(this.searchForm.value.toDate);
    console.log(this.subject)
    console.log(this.status)
    console.log(this.from)
    console.log(this.to)
    this.getNotifications();
  }

  clear() {
    this.searchForm.patchValue(
      {
        subject: [''],
        status: [''],
        fromDate: [''],
        toDate: ['']
      }
    );
    this.totalItems = 0;
    this.itemsPerPage = 10;
    this.page = 1;
    this.previousPage = this.page;
    this.subject = null;
    this.status = null;
    this.from = null;
    this.to = null;
    this.getNotifications();
  }

  
  getNotifications() {
    let url = "/bulk/notifications/" + this.page + "/" + this.itemsPerPage + "?subject=" + this.subject + "&status=" + this.status + "&from=" + this.from + "&to=" + this.to;
    this.apiService.get(url).subscribe(
      response => {
        this.data = response.data.result.tableData;

        this.totalItems = response.data.result.totalItems;
        this.itemsPerPage = response.data.result.itemsPerPage;
        this.page = response.data.result.page;
      },
      error => {
      }
    );
  }

  loadPage(selectedPage: number) {
    console.log("Selected page : "+selectedPage);
    if (selectedPage !== this.previousPage) {
      this.previousPage = selectedPage;
      this.getNotifications();
    }
  }

  getDate(date): string {
    if (date != null && date != undefined && date != '') {
      date = date.year + '-' + (date.month < 10 ? "0" + date.month : date.month) + '-' + (date.day < 10 ? '0' + date.day : date.day);
      console.log("yyyy-mm-dd : " + date);
    }
    return date;
  }

  private createForm() {
    this.searchForm = this.formBuilder.group({
      subject: [''],
      status: [''],
      fromDate: [''],
      toDate: ['']
    });
  }

}
